import { produce } from 'immer';

import { UpdateInternalProductsForm } from '../../../actions/products/internal/updateInternalProductsForm';
import { ProductsState } from '../../../typings/products';

export function updateInternalProductsForm(state: ProductsState, action: UpdateInternalProductsForm): ProductsState {
    return produce(state, draft => {
        draft.productsForm = action.form;
    });
}
